module.exports = __webpack_public_path__ + "img/talkCloud.e25fffa0.svg";